import Vue from "vue";
import Router from "vue-router";
import services from "@/services";

import TemplateDefault from "@/components/Template/Default";
import TemplateLogin from "@/components/Template/Login";

import AuthRoutes from "@/modules/Auth/routes";
import ParceiroContratacaoRoutes from "@/modules/Parceiro/Contratacao/routes";

// register plugin
Vue.use(Router);

// define system routes
const CoreRoutes = [
  {
    path: "/",
    redirect: "/parceiro/contratacao",
    component: TemplateDefault,
    children: [
      ...ParceiroContratacaoRoutes
    ],
  },
];

// define auth routes
const CoreAuthRoutes = [
  {
    path: "/login",
    redirect: "/auth/login",
    component: TemplateLogin,
    children: [...AuthRoutes],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: TemplateLogin,
    children: [...AuthRoutes],
  },
];

// merge all routes
const routes = [...CoreRoutes, ...CoreAuthRoutes];

// isntaciete Router object
const router = new Router({ routes });

// check routes permitions
router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    const loggedIn = services.Auth.loggedIn()
    if (!loggedIn) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/modules/Router.js